import { render, staticRenderFns } from "./ggAndIcbuAndAsset.vue?vue&type=template&id=ffcd0f56&scoped=true"
import script from "./ggAndIcbuAndAsset.vue?vue&type=script&lang=js"
export * from "./ggAndIcbuAndAsset.vue?vue&type=script&lang=js"
import style0 from "./ggAndIcbuAndAsset.vue?vue&type=style&index=0&id=ffcd0f56&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffcd0f56",
  null
  
)

export default component.exports